import {
  BALANCE_PERIOD_TYPE,
  DEFAULT_MONTHLY_BALANCE_DAY,
  DEFAULT_MONTHLY_BALANCE_PERIOD,
} from '../../../constants/service/app/balanceConstants';
import { CONFIRM_TAG_LIST_TYPE, TAG_GROUP_KIND } from '../../../constants/service/app/tagConstants';
import { ACCOUNT_SELLER_STATUS } from '../../../constants/service/app/accountSellerConstants';
import { PRODUCT_MANAGEMENT_TYPE } from '../../../constants/service/app/productConstants';
import { BRAND_TYPE } from '../../../constants/service/app/brandConstants';

/**
 *   입점승인 판매점 리스트 필터 옵션 모델
 */
export const BRAND_JOIN_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상점 id
   */
  storeId: null,
  /**
   *  판매점 상태
   */
  status: ACCOUNT_SELLER_STATUS.REQUEST,
  /**
   *  판매점 티어
   */
  tier: null,
  /**
   *  판매자 유형
   */
  businessType: null,
  /**
   *  신청일자
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  처리일자
   */
  confirmDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  판매점 명
   */
  storeName: null,
  /**
   *  담당자
   */
  name: null,
  /**
   *  이메일
   */
  email: null,
  /**
   *  핸드폰
   */
  phone: null,
  /**
   *  유선전화
   */
  extraPhone: null,
};

/**
 *  입점승인 판매점 리스트 정렬 옵션 모델
 */
export const BRAND_JOIN_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  브랜드 리스트 필터 옵션 모델
 */
export const BRAND_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상점 id
   */
  storeId: null,
  /**
   *  브랜드 명
   */
  storeName: null,
  /**
   *  상태
   */
  status: null,
  /**
   *  티어
   */
  tier: null,
  /**
   *  AS 전화번호
   */
  asPhone: null,
  /**
   *  사업자등록번호
   */
  businessLicenseNumber: null,
};

/**
 *  브랜드 리스트 정렬 옵션 모델
 */
export const BRAND_LIST_SORT_OPTION_MODEL = [
  /**
   *  브랜드 티어 정렬
   */
  {
    id: 'tier',
    desc: false,
  },
  /**
   * 브랜드 티어별 순서 정렬
   */
  {
    id: 'no',
    desc: false,
  },
];

/**
 *  브랜드 태그 검수 리스트 정렬 옵션 모델
 */
export const BRAND_TAG_REQUEST_LIST_SORT_OPTION_MODEL = [
  {
    id: 'confirmStoreTagCreateDate',
    desc: true,
  },
];

/**
 *  브랜드 리스트 페이지 - summary box 모델
 */
export const BRAND_SUMMARY_BOX_MODEL = {
  /**
   * 전체 판매자 수
   */
  storeCount: null,
  /**
   *  활성중인 판매자 수
   */
  activeStoreCount: null,
  /**
   *  전체 브랜드 찜 수
   */
  storeLikeCount: null,
  /**
   *  전체 상품 찜 수
   */
  productLikeCount: null,
  /**
   *  전체 판매액
   */
  sumTotalPrice: null,
};

/**
 *  브랜드 상세 > 브랜드 정보 > 입점상태 정보
 */
export const BRAND_DETAIL_STATUS_MODEL = {
  /**
   *  입점상태
   */
  status: null,
  /**
   *  입점신청일자
   */
  confirmDate: null,
  /**
   *  승인처리일자
   */
  createDate: null,
  /**
   *  거절된 횟수
   */
  rejectCnt: null,
  /**
   *  거절 타입
   */
  rejectType: null,
  /**
   *  거절 사유
   */
  rejectReason: null,
};

/**
 *  브랜드 상세 > 브랜드 정보 > 담당자 정보
 */
export const BRAND_DETAIL_SELLER_MODEL = {
  /**
   *  판매자이메일
   */
  email: null,
  /**
   *  판매잠명
   */
  name: null,
  /**
   *  핸드폰
   */
  phone: null,
  /**
   *  유선전화
   */
  extraPhone: null,
};

/**
 *  브랜드 태그 모델
 */
export const BRAND_TAG_MODEL = {
  [CONFIRM_TAG_LIST_TYPE.ACTIVE]: [],
  [CONFIRM_TAG_LIST_TYPE.CONFIRM_READY]: [],
  [CONFIRM_TAG_LIST_TYPE.REJECT]: [],
  rejectInfo: {},
  confirmTagButtonType: CONFIRM_TAG_LIST_TYPE.ACTIVE,
};

/**
 *  브랜드 상세 > 브랜드 정보 > 브랜드 정보
 */
export const BRAND_DETAIL_BRAND_MODEL = {
  /**
   *  브랜드 메인이미지
   */
  mainImg: [],
  /**
   *  브랜드 서브이미지
   */
  subImg: [],
  /**
   *  상점명
   */
  storeName: null,
  /**
   *  상점영문명
   */
  storeEngName: null,
  /**
   *  티어
   */
  tier: null,
  /**
   *  티어별 순서
   */
  no: null,
  /**
   *  브랜드가 현재 티어에 등록되었는지 여부
   */
  isHaveTierBrand: false,
  /**
   *  브랜드를 노출 관리를 하고 있는지 여부
   */
  isRankBrand: false,
  /**
   *  브랜드 노출 여부
   */
  isExposureBrand: false,
  /**
   *  홈페이지 주소
   */
  homepageUrl: null,
  /**
   *  네이버 스토어 팜 주소
   */
  naverStoreFarmUrl: null,
  /**
   *  오프라인 주소
   */
  address: {
    city: null,
    line1: null,
    line2: null,
    postCode: null,
  },
  /**
   *  대표번호
   */
  storePhone: null,
  /**
   *  관리자 메모
   */
  memo: null,
  /**
   *  브랜드 컨셉 태그
   */
  [TAG_GROUP_KIND.CONCEPT]: BRAND_TAG_MODEL,
};

/**
 *  브랜드 상세 > 브랜드 정보 > 사업자 정보
 */
export const BRAND_DETAIL_BUSINESS_MODEL = {
  /**
   *  사업 유형
   */
  businessType: null,
  /**
   *  상호/법인명
   */
  companyName: null,
  /**
   *  대표자 명
   */
  ceoName: null,
  /**
   *  사업자 등록번호
   */
  businessLicenseNumber: null,
  /**
   *  사업자 등록번호 이미지
   */
  businessLicenseImg: [],
  /**
   *  통신판매업 신고 번호
   */
  onlineSalesRegNumber: null,
  /**
   *  통신판매업 신고 이미지
   */
  onlineSalesRegImg: [],
};

/**
 *  브랜드 상세 > 브랜드 정보 > 정산 정보
 */
export const BRAND_DETAIL_BALANCE_MODEL = {
  /**
   *  예금주
   */
  accountHolder: null,
  /**
   *  은행 리스트
   */
  bankSelectList: [],
  /**
   *  은행 아이디
   */
  bankId: null,
  /**
   *  계좌번호
   */
  accountNumber: null,
  /**
   *  통장사본이미지
   */
  bankBookCopyImg: [],
  /**
   *  전자세금계산서 이메일
   */
  storeEmail: null,
  /**
   *  정산주기 정보 리스트
   */
  balancePeriodInfoList: [
    {
      id: null,
      management: null,
      balancePeriodType: null,
      balanceDay: DEFAULT_MONTHLY_BALANCE_DAY,
      balancePeriod: DEFAULT_MONTHLY_BALANCE_PERIOD,
    },
  ],
  /**
   *  브랜드 수수료 정보 리스트
   */
  brandFeeInfoList: [
    {
      id: 'brand_fee_rate_1',
      management: BRAND_TYPE.BRAND,
      type: PRODUCT_MANAGEMENT_TYPE.ENTER,
      isPgFee: true,
      amondzFeeRate: 14,
      marketingFeeRate: 10,
      fulfillmentFeeRate: 0,
    },
  ],
  /**
   *  풀필먼트 판매 여부
   */
  enabledFulfillment: false,
  /**
   *  아몬즈 수수료 정보 리스트
   */
  amondzFeeInfoList: [
    {
      id: 'amondz_fee_rate_1',
      management: BRAND_TYPE.AMONDZ,
      type: PRODUCT_MANAGEMENT_TYPE.INCOME,
      isPgFee: true,
      amondzFeeRate: 5,
      marketingFeeRate: 10,
      fulfillmentFeeRate: 9,
    },
    {
      id: 'amondz_fee_rate_2',
      management: BRAND_TYPE.AMONDZ,
      type: PRODUCT_MANAGEMENT_TYPE.PURCHASE,
      isPgFee: false,
      amondzFeeRate: 0,
      marketingFeeRate: 0,
      fulfillmentFeeRate: 100,
    },
    {
      id: 'amondz_fee_rate_3',
      management: BRAND_TYPE.AMONDZ,
      type: PRODUCT_MANAGEMENT_TYPE.CONSIGNMENT_MANUFACTURE,
      isPgFee: false,
      amondzFeeRate: 0,
      marketingFeeRate: 0,
      fulfillmentFeeRate: 70,
    },
  ],
};

/**
 *  브랜드 상세 > 브랜드 정보 > SNS 정보 모델
 */
export const BRAND_DETAIL_SNS_ROWS_MODEL = [
  {
    no: 1,
    typeName: '인스타그램',
    url: null,
  },
  {
    no: 2,
    typeName: '페이스북',
    url: null,
  },
  {
    no: 3,
    typeName: '블로그',
    url: null,
  },
];

/**
 *  브랜드 상세 > 통계 정보 > 검색어 모델
 */
export const BRAND_DETAIL_STATISTIC_KEYWORD_MODEL = {
  dataTypeList: [],
  dateRange: null,
};

/**
 *  브랜드 상세 > 주문/정산 정보 > 주문/정산 주문 과정 정보
 */
export const BRAND_DETAIL_ORDER_BALANCE_COUNT_MODEL = {
  /**
   *  결제완료 주문상품 수
   */
  paymentDoneCount: null,
  /**
   *  상품 준비 주문상품 수
   */
  deliveryReadyCount: null,
  /**
   *  배송중 주문상품 수
   */
  deliveryIngCount: null,
  /**
   *  배송완료된 주문상품 수
   */
  deliveryDoneCount: null,
  /**
   *  구매확정된 주문상품 수
   */
  orderConfirmCount: null,
  /**
   *  취소요청된 주문상품 수
   */
  cancelCount: null,
  /**
   *  반품요청된 주문상품 수
   */
  returnCount: null,
  /**
   *  교환요청된 주문 상품 수
   */
  changeCount: null,
};

/**
 *  브랜드 상세 > 주문/정산 정보 >  정산 정보
 */
export const BRAND_DETAIL_ORDER_BALANCE_CALCULATE_MODEL = {
  /**
   *  누적 정산대기금액
   */
  totalFinalBalance: null,
  /**
   *  누적 정산집행금액
   */
  totalPaidBalance: null,
  /**
   *  누적 지급보류금액
   */
  totalHoldBalance: null,
  /**
   *  누적 추가정산금액
   */
  totalExtraBalance: null,
};

/**
 *  브랜드 상세 > 상품 정보 > 상품 취합 정보
 */
export const BRAND_DETAIL_PRODUCT_SUMMARY_MODEL = {
  /**
   *  전체 상품 수
   */
  totalProductCount: null,
  /**
   *  승인대기 상품 수
   */
  permitWaitingCount: null,
  /**
   *  거절 상품 수
   */
  permitRejectedCount: null,
  /**
   *  품절된 상품 수
   */
  soldOutCount: null,
  /**
   *  판매종료된 상품 수
   */
  closedCount: null,
  /**
   *  판매중지된 상품 수
   */
  stoppedCount: null,
  /**
   *  삭제된 상품 수
   */
  deletedCount: null,
  /**
   *  판매중인 상품 수
   */
  saleingProductCount: null,
  /**
   *  판매중인 귀걸이 상품 수
   */
  earringCount: null,
  /**
   *  판매중인 목걸이 상품 수
   */
  necklaceCount: null,
  /**
   *  판매중인 반지 상품 수
   */
  ringCount: null,
  /**
   *  판매중인 팔찌 상품 수
   */
  braceletCount: null,
};

/**
 *  브랜드 상세 > 공지사항 정보 > 검색 옵션
 */
export const BRAND_DETAIL_NOTICE_PRODUCT_FILTER_OPTION_MODEL = {
  /**
   *  상품 공지사항 상태
   */
  status: null,
  /**
   *  제목
   */
  title: null,
  /**
   *  내용
   */
  content: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  노출 기간
   */
  period: {
    startDate: null,
    endDate: null,
  },
  /**
   *  작성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  브랜드 상세 > 공지사항 정보 > 페이지네이션
 */
export const BRAND_DETAIL_NOTICE_PRODUCT_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  브랜드 상세 > 상품등록 정보 > 거래조건에 관한 정보
 */
export const BRAND_DETAIL_TRADING_CONDITION_MODEL = {
  /**
   *  브랜드 책임으로 인한 반품의 경우 반품 가능 기간 및 통신판매업자가 부담하는 반품비용에 대한 정보
   */
  refundBySeller: null,

  /**
   *  반품 / 교환 불가사유
   */
  cancelLimit: null,

  /**
   *  재화등의 교환·반품·보증 조건 및 품질보증기준
   */
  exchangeRefundGuarantee: null,

  /**
   *  대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른 배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조건 및 절차
   */
  deliveryDelay: null,

  /**
   *  소비자피해보상의 처리, 재화등에 대한 불만 처리 및 소비자와 사업자 사이의 분쟁처리에 관한 사항
   */
  consumerInjury: null,
};

/**
 *  브랜드 상세 > 상품등록 정보 > 추가 배송비
 */
export const BRAND_DETAIL_ADD_DELIVERY_CHARGE_MODEL = {
  /**
   *  제주 추가배송비
   */
  deliveryChargeReturn: null,

  /**
   *  제주외 도서산간 추가 배송비
   */
  deliveryChargeJeju: null,

  /**
   *  반품/교환 배송비(편도)
   */
  deliveryChargeEtc: null,
};

/**
 *  브랜드 상세 > 상품등록 정보 > 배송 정보
 */
export const BRAND_DETAIL_DELIVERY_INFO_MODEL = {
  /**
   *  출고지
   */
  originAddress: {
    city: null,
    line1: null,
    line2: null,
    postCode: null,
    memo: null,
  },

  /**
   *  반품/교환지
   */
  returnAddress: {
    city: null,
    line1: null,
    line2: null,
    postCode: null,
    memo: null,
  },
};

/**
 *  브랜드 상세 > 상품등록 정보 > A/S
 */
export const BRAND_DETAIL_AFTER_SERVICE_MODEL = {
  /**
   *  A/S 전화번호
   */
  asPhone: null,

  /**
   *  카카오톡 (플러스친구)
   */
  kakaoAccount: null,

  /**
   *  A/S 안내
   */
  asInform: null,

  /**
   *  착용시 주의 사항
   */
  caution: null,

  /**
   *  품질보증 기준
   */
  qualityAssurance: null,

  /**
   *  제조자
   */
  manufacturer: null,

  /**
   *  제조국
   */
  origin: null,
};

/**
 *  판매점 승인거절 모달 정보
 */
export const BRAND_REJECT_MODAL_MODEL = {
  /**
   *  상점 id
   */
  storeId: null,
  /**
   *  거절 타입 리스트
   */
  rejectTypeList: [],
  /**
   *  거절 상세 사유
   */
  rejectReason: null,
};

/**
 *  브랜드 티어 페이지 - 셀렉터 검색 모델
 */
export const BRAND_TIER_SELECTOR_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 명
   */
  storeName: null,
};

/**
 *  브랜드 노출관리 페이지 - 셀렉터 검색 모델
 */
export const BRAND_EXPOSURE_SELECTOR_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 명
   */
  storeName: null,
  /**
   *  매장 검색 시 노출 여부
   */
  isSearch: {
    /**
     *  노출되고 있지 않은 매장
     */
    inActive: false,
    /**
     *  노출되고 있는 매장
     */
    active: false,
  },
};
